<div class="screen-container" [loading]="loading()">
	<div class="mt-4">
		<lgb-back name="collect-home"></lgb-back>
	</div>

	<div class="search-container">
		<label class="input input-bordered input-lg w-full gap-2">
		  <input 
		  	autoFocus
		  	type="text" 
		  	class="grow placeholder:text-base-content/60"
		  	placeholder="Recherchez une carte..."
		  	#searchable="searchable"
		  	[(ngModel)]="qSearch"
		  	[qSearch]="qSearch()"
		  	[search]="getSearch$()"
		  	[(results)]="results"
		  	[(searching)]="loading"
		  	[length]="length"
		  	[autoload]="autoLoad()"
		  	[start]="currentPage()"
		  	(setPage)="currentPage.set($event)"
		  />
		  <span class="opacity-60"><i class="fa-light fa-magnifying-glass"></i></span>
		</label>
	</div>

	@if(results().length && qSearch()?.trim()!=''){
		<div class="card-container">
			@for(card of results(); track card.ident){
				<a [routerLink]="router.parse('card-index', [card.ident])" [queryParams]="{backTo: backTo()}" class="element-show card mb-4" [style.--i]="$index">
					<img class="shadow-sm" hSkeleton="250px" [altImg]="cardS.getImages(card.img)" [attr.loading]="(($index>10)? 'lazy' : null)"/>
				</a>
			}
		</div>
		<div class="pagination mt-4">
			<div class="join">
			  @if(searchable.canPrev()){
		  	  	<button (click)="searchable.prev()" class="join-item btn">«</button>
		  	  }
			  <button class="join-item btn">Page {{searchable.page()+1}}</button>
			  @if(searchable.canNext()){
			  	<button (click)="searchable.next()" class="join-item btn">»</button>
			  }
			</div>
		</div>
	}
	@else{
		<div class="empty-container">
			<img src="img/skin/empty-search.svg"/>
			<p class="opacity-60">
				Aucun résultat ? Essaie avec le nom anglais.
			</p>
		</div>
	}
</div>